module.exports = __webpack_public_path__ + "static/img/house1.4651479.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/house1.jpg
// module id = vQM1
// module chunks = 0